import React from "react";
import cn from "classnames";
import styled, { css } from "styled-components";

interface IStatusTagProps {
  value?: string;
  level?: string;
  cancel?: boolean;
}

const StatusTag = (props: IStatusTagProps) => {
  return (
    <StatusTagWrap>
      <StatusBar className={cn({ cancel: props.cancel })}>
        <li className={cn({ active: props.level === "20" })}>
          <span className="hidden">접수중</span>
        </li>
        <li className={cn({ active: props.level === "40" })}>
          <span className="hidden">업체배정</span>
        </li>
        <li className={cn({ active: props.level === "60" })}>
          <span className="hidden">견적진행</span>
        </li>
        <li className={cn({ active: props.level === "80" })}>
          <span className="hidden">A/S진행</span>
        </li>
        <li className={cn({ active: props.level === "100" })}>
          <span className="hidden">완료</span>
        </li>
      </StatusBar>
      <StatusTagSet>{props.cancel ? "취소" : props.value}</StatusTagSet>
    </StatusTagWrap>
  );
};

const StatusTagWrap = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin()}
`;

const StatusBar = styled.ul<IStatusTagProps>`
  z-index: 1;
  position: relative;
  display: inline-block;
  width: 114px;
  height: 10px;
  margin-right: 10px;
  ${({ theme }) => theme.flexBox.flexMixin()}
  &::before {
    content: "";
    z-index: -1;
    position: absolute;
    left: 0;
    top: 4px;
    width: 100%;
    height: 1px;
    background-color: #dbe1f4;
  }
  > li {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #dbe1f4;
    &.active {
      border: 2px solid ${({ theme }) => theme.color.subMain};
      background-color: #fff;
    }
  }
  &.cancel {
    &::before {
      background-color: ${({ theme }) => theme.color.warning};
    }
    > li {
      background-color: ${({ theme }) => theme.color.warning};
      &.active {
        border: 2px solid ${({ theme }) => theme.color.warning};
        background-color: #fff;
      }
    }
  }
`;

const StatusTagSet = styled.span`
  display: inline-block;
  min-width: 46px;
  height: 16px;
  line-height: 16px;
  padding: 0 2px;
  border-radius: 2px;
  background-color: #12182d;
  color: #fff;
  font-size: 12px;
  text-align: center;
  letter-spacing: -1px;
  /* > .status-list {
    ${(props) => {
    switch (props.color) {
      case "level0":
        return css`
          background-color: ${({ theme }) => theme.color.warning};
        `;
      case "level1":
        return css`
          background-color: ${({ theme }) => theme.color.bgPrimary};
          color: ${({ theme }) => theme.color.primary};
        `;
      case "level2":
        return css`
          background-color: #9fbcec;
        `;
      case "level3":
        return css`
          background-color: #96aff0;
        `;
      case "level4":
        return css`
          background-color: #6487eb;
        `;
      case "level5":
        return css`
          background-color: ${({ theme }) => theme.color.main};
        `;
      default:
        return css`
          background-color: #ebf0f5;
          color: #60677d;
        `;
    }
  }}
  } */
`;

export default StatusTag;
